import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TableWrapper } from "../../../components/common/Common.styles";
import { WalletTransactionItemType } from "../../../types/walletTypes";
import TransactionsTableHeader from "./TransactionsTableHeader";
import TransactionsTableRow from "./TransactionsTableRow";

interface Props {
  transactions: WalletTransactionItemType[];
}

export default function TransactionsTable({ transactions }: Props) {
  const { t } = useTranslation();

  if (!transactions || transactions.length === 0) {
    return (
      <Typography variant="body1" sx={{ mt: 2, color: "text.secondary" }}>
        {t("wallet.transactions.noTransactions")}
      </Typography>
    );
  }

  return (
    <TableWrapper
      minWidth="1100px"
      columnsTemplate="1fr 1fr 1fr 1fr 1fr 1fr"
      sx={{ backgroundColor: theme => theme.palette.background.paper }}
    >
      <TransactionsTableHeader />
      <Box sx={{ display: "contents" }}>
        {transactions.map((tx) => (
          <TransactionsTableRow key={tx.id} transaction={tx} />
        ))}
      </Box>
    </TableWrapper>
  );
}
